/**
 * Relewise-powered 404 product row: popular products from the last 14 days
 * (display location "404 Page"), rendered through the theme's own card via
 * /products/<handle>?view=relewise-card. Loaded by sections/spejder-404.liquid
 * only when the Relewise theme setting is on; the whole block is removed if
 * nothing can be recommended, mirroring the section's server-side empty state.
 */
!(function () {
  'use strict';

  var grid = document.querySelector('[data-relewise-404-grid]');
  if (!grid) return;

  /* This row shows one wide card per view on phones (100vw - 86px, 274–344px),
     but ?view=relewise-card has no layout to go on and says 200px there
     (snippets/product-grid-item). Swapped in before the images are requested;
     same value as the server-rendered fallback in sections/spejder-404. */
  var CARD_SIZES = '(max-width: 749px) calc(100vw - 86px), 500px';

  var cfg = window.spejder && window.spejder.relewise;
  var block = grid.closest('[data-relewise-404]');
  var fail = function () { if (block) block.remove(); };

  if (!cfg || !cfg.enabled || !window.Relewise) {
    fail();
    return;
  }

  /* Search page (2026-09-10, Magnus): the same "Måske er du interesseret i"
     row rescues a search with no hits. The section renders the block hidden
     with data-relewise-404-lazy; relewise-listing.js reveals it and fires
     relewise:no-results only when a term (without filters) found nothing, so
     no recommendations are fetched for searches that do have results. */
  if (block && block.hasAttribute('data-relewise-404-lazy')) {
    document.addEventListener('relewise:no-results', run, { once: true });
    return;
  }
  run();

  function run() {
  var limit = parseInt(grid.getAttribute('data-limit')) || 4;
  var location = grid.getAttribute('data-location') || '404 Page';
  var handleKey = cfg.shop + '_ShopifyHandle';

  /* Consent-correct identity via the shared helper (assets/relewise-batch.js),
     which waits for the app embed's global instead of testing for it now. */
  var userPromise = window.spejder.relewiseUser
    ? window.spejder.relewiseUser()
    : Promise.resolve(Relewise.UserFactory.anonymous());

  userPromise
    .then(function (user) {
      var request = new Relewise.PopularProductsBuilder({
        language: cfg.language,
        currency: cfg.currency,
        displayedAtLocation: location,
        user: user,
      })
        .sinceMinutesAgo(20160)
        .setNumberOfRecommendations(limit)
        .setSelectedProductProperties({ dataKeys: [handleKey] })
        .build();
      var recommender = new Relewise.Recommender(cfg.datasetId, cfg.apiKey, { serverUrl: cfg.serverUrl });
      return recommender.recommendPopularProducts(request);
    })
    .then(function (result) {
      var handles = ((result && result.recommendations) || []).map(function (rec) {
        return rec.data && rec.data[handleKey] && rec.data[handleKey].value;
      }).filter(Boolean);
      if (!handles.length) { fail(); return; }
      return Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '?view=relewise-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        cards = cards.filter(Boolean);
        if (!cards.length) { fail(); return; }
        /* Parsed in a <template> so no image loads before its sizes is set. */
        var tpl = document.createElement('template');
        tpl.innerHTML = cards.join('');
        tpl.content.querySelectorAll('img[sizes]').forEach(function (img) { img.setAttribute('sizes', CARD_SIZES); });
        grid.innerHTML = '';
        grid.appendChild(tpl.content);
        grid.setAttribute('data-relewise-ready', ''); // release the skeleton hold
        grid.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
      });
    })
    .catch(fail);
  }
})();
